/**
 * Display formatting for admin analytics number figures.
 */
export function formatAttemptsValue(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—';
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}

/** Attempts sparkline tooltip: the number plus the figure's unit, or an em dash. */
export function formatAttemptsTooltipValue(
  value: number | null | undefined,
  unit: string,
): string {
  const shown = formatAttemptsValue(value);
  if (shown === '—') return shown;
  return `${shown} ${unit}`;
}

/** Headline / value node for score gain (unit is separate). */
export function formatScoreGainFigureValue(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—';
  const sign = value > 0 ? '+' : '';
  const body = Number.isInteger(value) ? String(value) : value.toFixed(1);
  return `${sign}${body}`;
}

export const SCORE_GAIN_FIGURE_UNIT = 'pp';

/** Combined string for sparkline tooltips. */
export function formatScoreGainPp(value: number | null | undefined): string {
  const shown = formatScoreGainFigureValue(value);
  if (shown === '—') return shown;
  return `${shown} ${SCORE_GAIN_FIGURE_UNIT}`;
}

/** Headline / value node for percent figures (unit is separate). */
export function formatPercentFigureValue(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—';
  const body = Number.isInteger(value) ? String(value) : value.toFixed(1);
  return body;
}

export const PERCENT_FIGURE_UNIT = '%';

/** Combined percent for tooltips and captions. */
export function formatPercentValue(value: number | null | undefined): string {
  const shown = formatPercentFigureValue(value);
  if (shown === '—') return shown;
  return `${shown}${PERCENT_FIGURE_UNIT}`;
}

export function formatCountValue(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—';
  return String(Math.round(value));
}
